(() => {
  const ROOT_SELECTOR = '[data-bb-appointments]';

  function getEmbedUrl(rawUrl) {
    if (!rawUrl) return '';

    try {
      const url = new URL(rawUrl, window.location.origin);

      // Zoom's embedded booking-page mode.
      url.searchParams.set('embed', 'true');

      // Helpful source tracking inside Zoom Scheduler.
      if (!url.searchParams.has('utm_source')) {
        url.searchParams.set('utm_source', 'bnbfirearms');
      }
      if (!url.searchParams.has('utm_medium')) {
        url.searchParams.set('utm_medium', 'website');
      }

      return url.toString();
    } catch (error) {
      console.error('Invalid Zoom Scheduler URL:', rawUrl, error);
      return '';
    }
  }

  function init(root) {
    if (!root || root.dataset.bbInitialized === 'true') return;
    root.dataset.bbInitialized = 'true';

    const services = [...root.querySelectorAll('[data-service]')];
    const placeholder = root.querySelector('[data-placeholder]');
    const zoomPanel = root.querySelector('[data-zoom-panel]');
    const selectedName = root.querySelector('[data-selected-name]');
    const changeButton = root.querySelector('[data-change-service]');
    const iframeWrap = root.querySelector('[data-iframe-wrap]');
    const iframe = root.querySelector('[data-zoom-iframe]');
    const missingUrl = root.querySelector('[data-missing-url]');

    function clearSelection() {
      services.forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });

      if (iframe) iframe.removeAttribute('src');
      if (iframeWrap) iframeWrap.hidden = true;
      if (missingUrl) missingUrl.hidden = true;
      if (zoomPanel) zoomPanel.hidden = true;
      if (placeholder) placeholder.hidden = false;
    }

    function selectService(button) {
      services.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const serviceName = button.dataset.serviceName || 'Appointment';
      const rawUrl = button.dataset.zoomUrl || '';
      const embedUrl = getEmbedUrl(rawUrl);

      placeholder.hidden = true;
      zoomPanel.hidden = false;
      selectedName.textContent = serviceName;

      if (!embedUrl) {
        iframe.removeAttribute('src');
        iframeWrap.hidden = true;
        missingUrl.hidden = false;
        return;
      }

      missingUrl.hidden = true;
      iframeWrap.hidden = false;

      if (iframe.src !== embedUrl) {
        iframe.src = embedUrl;
      }

      if (window.matchMedia('(max-width: 989px)').matches) {
        requestAnimationFrame(() => {
          zoomPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    services.forEach((button) => {
      button.addEventListener('click', () => selectService(button));
    });

    changeButton?.addEventListener('click', () => {
      clearSelection();
      services[0]?.focus({ preventScroll: true });
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
